import { Flex, RefreshIcon } from '@mprolab/uikit'
import styled from 'styled-components'

export const RotatingRefreshCcw = styled(RefreshIcon)<{ refresh: boolean }>`
  cursor: pointer;
  animation: ${({ refresh }) => (refresh ? 'rotation' : 'none')} 1s;
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`

export const RefreshPlaceholder = styled(Flex)<{ refresh: boolean; width: string; height?: string }>`
  width: ${({ width }) => width}px;
  background: ${({ theme }) => theme.colors.gray7};
  height: ${({ height }) => height || '14px'};
  border-radius: 8px;
  animation: ${({ refresh }) => (refresh ? 'opacity' : 'none')} infinite 1s linear;
  @keyframes opacity {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }
`
